import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import BreedServices from '../components/BreedServices';
import BreadCumbrongeur from '../components/catlists/BreadCumbRong';
import Faq from '../components/Faq';
import ShopAreaRongeur from '../components/ourshop/ShoAreaRongeur';


function RongeurList() {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);


    return (

        <main>
            <Helmet>
                <title>Rongeurs - Animalia</title>
                <meta name="description" content="Découvrez notre sélection de nos produits pour rongeurs chez Animalia." />
            </Helmet>

            <BreadCumbrongeur />
            {/* <DogsList/> */}
            <ShopAreaRongeur />
            {/* <AdoptionShop/> */}
            <Faq afterElment="faq-area-two" />
            <BreedServices />
            {/* <NewsLetter /> */}
        </main>
    )
}

export default RongeurList;
